export const Translations_AT = {
	footer: {
		join: "Nimm jetzt an der Diskussion teil. Keine App und kein Login benötigt.",
		climate: "Eine klimapositive Diskussion.",
		tree: "Dieser Baum wurde gepflanzt.",
		start: "Beginne jetzt gratis deine Videodiskussion. ",
	},
};
